export default [{
  name: 'woori-crowd',
  path: '/woori-crowd',
  beforeEnter(to, from, next) {
    next()
  },
  component: require('@/views/woori-crowd/Main.vue').default
}, {
  name: 'woori-crowd/detail',
  path: '/woori-crowd/:uuid',
  beforeEnter(to, from, next) {
    next()
  },
  props: (route) => ({ uuid: route.params.uuid }),
  component: require('@/views/woori-crowd/Detail.vue').default
},
{
  name: 'woori-crowd/detail/application',
  path: '/woori-crowd/:uuid/application',
  beforeEnter(to, from, next) {
    next()
  },
  props: (route) => ({ uuid: route.params.uuid }),
  component: require('@/views/woori-crowd/Application.vue').default
}]
